<template>
  <PaypalButton
    class="paypal-express-checkout-button"
    :label="label"
    is-label-before
    :size="size"
    @click="handleCheckoutStart"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import { PaypalButton } from '@i22-td-smarthome/component-library';
import { handleCartErrors } from '@/helpers/add-to-cart';
import AddToCart from '~/mixins/add-to-cart';

export default defineComponent({
  name: 'PaypalExpressCheckoutButton',
  components: {
    PaypalButton,
  },
  mixins: [AddToCart],
  props: {
    label: {
      type: String,
      default: 'Direkt zu',
    },
    offer: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'medium',
      validator(value) {
        return ['small', 'medium', 'large'].includes(value);
      },
    },
  },
  emits: ['checkout:success', 'checkout:start', 'checkout:failure'],
  methods: {
    ...mapActions('order', ['submitPaypalExpressOrder']),
    handleCheckoutSuccess(redirect) {
      this.$emit('checkout:success', redirect);
      window.location.href = redirect;
      setTimeout(() => {
        this.$flyout.close();
      }, 5000);
    },
    handleCheckoutFailure(error) {
      handleCartErrors(
        error,
        (articleNumber) => {
          const item = this.getItem(articleNumber);
          return item?.name || articleNumber;
        },
        'Die Weiterleitung zu PayPal konnte nicht durchgeführt werden.'
      );
      this.$emit('checkout:failure', error);
    },
    async handleCheckoutStart() {
      this.$emit('checkout:start');
      if (this.offer && Object.keys(this.offer).length > 0) {
        if (!(await this.addOfferToCart())) {
          return;
        }
      }
      this.showPaypalExpressStartDialog().then(() => {});

      try {
        const { redirect } = await this.submitPaypalExpressOrder();

        if (!redirect) {
          this.handleCheckoutFailure(
            new Error('Die Weiterleitung zu PayPal konnte nicht durchgeführt werden.')
          );
          return;
        }

        this.handleCheckoutSuccess(redirect);
      } catch (error) {
        this.handleCheckoutFailure(error);
      }
    },
    offerAddedToCart(items) {},

    async showPaypalExpressStartDialog() {
      await this.$flyout.info('Du wirst zu PayPal weitergeleitet ...', { type: 'info' });
    },
  },
});
</script>
